import React from "react";
import { Link } from "react-router-dom";
import { Star, MapPin, BadgeCheck, Zap, Phone } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolveUrl = (u) => (!u ? u : (u.startsWith("http") ? u : `${BACKEND}${u}`));

export default function TrainerCard({ t }) {
  return (
    <Link
      to={`/trainer/${t.slug || t.id}`}
      data-testid={`trainer-card-${t.id}`}
      className="card-fl block group"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-neutral-100">
        {t.photo_url ? (
          <img src={resolveUrl(t.photo_url)} alt={t.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full grid place-items-center text-neutral-400">No photo</div>
        )}
        {t.featured && (
          <span className="absolute top-3 left-3 rounded-full bg-emerald-600/95 text-white text-xs font-bold uppercase tracking-widest px-2.5 py-1">Featured</span>
        )}
        <span className="absolute top-3 right-3 rounded-full bg-white/95 text-neutral-900 text-xs font-bold px-2.5 py-1 inline-flex items-center gap-1">
          <BadgeCheck size={12} className="text-emerald-600"/> Verified
        </span>
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="text-base font-bold text-neutral-900 group-hover:text-emerald-600 transition-colors">{t.name}</h3>
            <div className="text-sm text-neutral-500 mt-0.5 flex items-center gap-1">
              <MapPin size={12}/> {t.city || t.county || "Ireland"}
            </div>
          </div>
          <div className="text-right">
            <div className="text-sm inline-flex items-center gap-1 font-semibold">
              <Star size={14} className="star-on fill-emerald-600"/> {t.rating_avg?.toFixed(1) || "New"}
            </div>
            <div className="text-xs text-neutral-500">{t.rating_count || 0} reviews</div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {(t.specialities || []).slice(0, 3).map((s) => (
            <span key={s} className="text-xs bg-neutral-100 text-neutral-700 rounded-full px-2 py-0.5">{s}</span>
          ))}
        </div>
        <div className="mt-4 flex items-end justify-between">
          <div>
            <span className="text-lg font-black text-neutral-900">€{t.hourly_rate || 0}</span>
            <span className="text-xs text-neutral-500 ml-1">/ session</span>
          </div>
          {t.online_coaching && (
            <span className="text-xs inline-flex items-center gap-1 text-emerald-700 font-semibold">
              <Zap size={12}/> Online
            </span>
          )}
        </div>
        <div className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-emerald-300 bg-emerald-50 text-emerald-700 px-2.5 py-1 text-[11px] font-bold uppercase tracking-widest">
          <Phone size={11}/> Free 15-min intro call
        </div>
      </div>
    </Link>
  );
}
